module.exports = __webpack_public_path__ + "static/media/img-signin.324c8d2a.jpg";